import { defineComponent, computed, ref, createElementBlock, createCommentVNode, unref, openBlock, normalizeClass, createElementVNode, Fragment, createBlock, createTextVNode, toDisplayString, renderList, createVNode, withCtx } from 'vue';
import { useWindowSize } from './basler-components.es354.js';
import _sfc_main$1 from './basler-components.es91.js';
/* empty css                       */
import _sfc_main$2 from './basler-components.es161.js';
/* empty css                        */
import _sfc_main$3 from './basler-components.es83.js';
/* empty css                       */

const _hoisted_1 = { class: "cart-quick-view__inner" };
const _hoisted_2 = { class: "login-quick-view__scrollbox" };
const _hoisted_3 = { class: "cart-quick-view__cart" };
const _hoisted_4 = { class: "cart-quick-view__summary" };
const _hoisted_5 = { class: "cart-quick-view__count" };
const _hoisted_6 = { class: "cart-quick-view__subtotal" };
const _hoisted_7 = {
  key: 0,
  class: "cart-quick-view__items"
};
const _hoisted_8 = {
  key: 0,
  class: "cart-quick-view__show-more"
};
const _hoisted_9 = {
  key: 1,
  class: "cart-quick-view__cta"
};
const _hoisted_10 = { class: "cart-quick-view__footer" };
const _hoisted_11 = {
  key: 1,
  class: "cart-quick-view__no-items"
};
const _hoisted_12 = { key: 0 };
const _hoisted_13 = {
  key: 1,
  class: "cart-quick-view__seperator"
};
const _hoisted_14 = {
  key: 2,
  class: "cart-quick-view__footer"
};
const _hoisted_15 = { key: 0 };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "CartQuickView",
  props: {
    isOpen: { type: Boolean },
    carts: {},
    noItems: {}
  },
  emits: ["cart-type-change", "item-remove", "navigate"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const { height } = useWindowSize();
    const itemsToDisplay = computed(() => {
      if (height.value <= 800) {
        return 1;
      }
      if (height.value < 1e3) {
        return 3;
      }
      return 4;
    });
    const carts = props.carts ? ref(props.carts) : ref([]);
    const cartControls = computed(() => {
      if (carts.value && carts.value.length) {
        return carts.value.filter((cart) => cart.items && cart.items.length).map((cart) => {
          return {
            id: cart.id,
            title: cart.title,
            isActive: cart.isActive
          };
        });
      } else {
        return [];
      }
    });
    const activeCart = computed(() => {
      if (carts.value && carts.value.length) {
        return carts.value.find((cart) => cart.isActive);
      } else {
        return void 0;
      }
    });
    const activeCartItems = computed(() => {
      let activeCartItems2 = void 0;
      if (activeCart.value && "items" in activeCart.value && Array.isArray(activeCart.value.items) && activeCart.value.items.length) {
        activeCartItems2 = activeCart.value.items.slice(0, itemsToDisplay.value);
      }
      return activeCartItems2;
    });
    const onCartTypeChange = (cartControl) => {
      carts.value.forEach((cart) => {
        cart.isActive = cart.id === cartControl.id;
      });
      emit("cart-type-change", cartControl);
    };
    const onItemRemove = (item) => {
      emit("item-remove", item);
    };
    return (_ctx, _cache) => {
      return unref(carts) ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(["cart-quick-view", { "is-open": _ctx.isOpen }])
      }, [
        _cache[9] || (_cache[9] = createElementVNode("div", { class: "cart-quick-view__arrow" }, null, -1)),
        createElementVNode("div", _hoisted_1, [
          createElementVNode("div", _hoisted_2, [
            activeCart.value && "items" in activeCart.value ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
              cartControls.value && cartControls.value.length > 1 ? (openBlock(), createBlock(_sfc_main$1, {
                key: 0,
                class: "cart-quick-view__controls",
                controls: cartControls.value,
                onChange: onCartTypeChange
              }, null, 8, ["controls"])) : createCommentVNode("", true),
              createElementVNode("div", _hoisted_3, [
                createElementVNode("div", _hoisted_4, [
                  createElementVNode("div", _hoisted_5, [
                    createElementVNode("strong", null, toDisplayString(activeCart.value.summary.itemCount), 1),
                    createTextVNode(" " + toDisplayString(activeCart.value.summary.itemCountText), 1)
                  ]),
                  createElementVNode("div", _hoisted_6, [
                    createTextVNode(toDisplayString(activeCart.value.summary.subtotalText), 1),
                    _cache[6] || (_cache[6] = createElementVNode("br", null, null, -1)),
                    createElementVNode("strong", null, toDisplayString(activeCart.value.summary.subtotal), 1)
                  ])
                ]),
                _cache[7] || (_cache[7] = createElementVNode("hr", { class: "cart-quick-view__seperator" }, null, -1)),
                activeCartItems.value ? (openBlock(), createElementBlock("div", _hoisted_7, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(activeCartItems.value, (item) => {
                    return openBlock(), createBlock(_sfc_main$2, {
                      key: `${item.id}${item.title}`,
                      id: item.id,
                      title: item.title,
                      text: item.text,
                      link: item.link,
                      media: item.media,
                      "amount-label": item.amountLabel,
                      amount: item.amount,
                      "price-label": item.priceLabel,
                      price: item.price,
                      "remove-action-label": item.removeActionLabel,
                      onRemove: onItemRemove,
                      onNavigate: _cache[0] || (_cache[0] = ($event) => emit("navigate"))
                    }, null, 8, ["id", "title", "text", "link", "media", "amount-label", "amount", "price-label", "price", "remove-action-label"]);
                  }), 128)),
                  activeCart.value.items.length > itemsToDisplay.value ? (openBlock(), createElementBlock("div", _hoisted_8, [
                    createVNode(_sfc_main$3, {
                      cssClass: "cart-quick-view__show-more-link",
                      link: activeCart.value.ctaLinkItem.link,
                      onClick: _cache[1] || (_cache[1] = ($event) => emit("navigate"))
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(activeCart.value.moreItemsText), 1)
                      ]),
                      _: 1
                    }, 8, ["link"])
                  ])) : createCommentVNode("", true)
                ])) : createCommentVNode("", true),
                _cache[8] || (_cache[8] = createElementVNode("hr", { class: "cart-quick-view__seperator" }, null, -1)),
                activeCart.value.ctaLinkItem ? (openBlock(), createElementBlock("div", _hoisted_9, [
                  createVNode(_sfc_main$3, {
                    "style-type": "attraction",
                    link: activeCart.value.ctaLinkItem.link,
                    onClick: _cache[2] || (_cache[2] = ($event) => emit("navigate"))
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(activeCart.value.ctaLinkItem.title), 1)
                    ]),
                    _: 1
                  }, 8, ["link"])
                ])) : createCommentVNode("", true),
                createElementVNode("div", _hoisted_10, [
                  createElementVNode("small", null, [
                    createTextVNode(toDisplayString(activeCart.value.footer.text) + " ", 1),
                    createVNode(_sfc_main$3, {
                      link: activeCart.value.footer.linkItem.link,
                      onClick: _cache[3] || (_cache[3] = ($event) => emit("navigate"))
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(activeCart.value.footer.linkItem.title), 1)
                      ]),
                      _: 1
                    }, 8, ["link"])
                  ])
                ])
              ])
            ], 64)) : (openBlock(), createElementBlock("div", _hoisted_11, [
              _ctx.noItems && _ctx.noItems.text ? (openBlock(), createElementBlock("p", _hoisted_12, [
                createTextVNode(toDisplayString(_ctx.noItems.text) + " ", 1),
                _ctx.noItems.linkItem ? (openBlock(), createBlock(_sfc_main$3, {
                  key: 0,
                  link: _ctx.noItems.linkItem.link,
                  onClick: _cache[4] || (_cache[4] = ($event) => emit("navigate"))
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(_ctx.noItems.linkItem.title), 1)
                  ]),
                  _: 1
                }, 8, ["link"])) : createCommentVNode("", true)
              ])) : createCommentVNode("", true),
              _ctx.noItems && _ctx.noItems.footer ? (openBlock(), createElementBlock("hr", _hoisted_13)) : createCommentVNode("", true),
              _ctx.noItems && _ctx.noItems.footer ? (openBlock(), createElementBlock("div", _hoisted_14, [
                _ctx.noItems.footer.text ? (openBlock(), createElementBlock("small", _hoisted_15, [
                  createTextVNode(toDisplayString(_ctx.noItems.footer.text) + " ", 1),
                  _ctx.noItems.footer.linkItem ? (openBlock(), createBlock(_sfc_main$3, {
                    key: 0,
                    link: _ctx.noItems.footer.linkItem.link,
                    onClick: _cache[5] || (_cache[5] = ($event) => emit("navigate"))
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(_ctx.noItems.footer.linkItem.title), 1)
                    ]),
                    _: 1
                  }, 8, ["link"])) : createCommentVNode("", true)
                ])) : createCommentVNode("", true)
              ])) : createCommentVNode("", true)
            ]))
          ])
        ])
      ], 2)) : createCommentVNode("", true);
    };
  }
});

export { _sfc_main as default };
